module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    attrs: {
      "id": "got-award"
    }
  }, [_c('div', {
    staticClass: "mask",
    attrs: {
      "data-spider": "getaward"
    },
    on: {
      "touchmove": _vm.touchMove
    }
  }, [_c('div', {
    class: ['content', _vm.code ? 'code' : '']
  }, [_c('div', {
    staticClass: "img",
    style: ({
      backgroundImage: ("url(" + _vm.img + ")")
    })
  }), _vm._v(" "), (_vm.awardType === 2 || _vm.awardType === 1) ? _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.name))]) : _vm._e(), _vm._v(" "), (_vm.awardType === 1) ? _c('div', [(!_vm.code) ? _c('div', {
    staticClass: "link",
    attrs: {
      "data-spider": ""
    },
    on: {
      "click": _vm.goInfoPage
    }
  }, [_c('div', {
    staticClass: "get-code",
    attrs: {
      "data-awardid": _vm.awardId
    }
  }, [_vm._v("获取兑奖码")])]) : _c('div', {
    staticClass: "link",
    attrs: {
      "data-spider": ""
    },
    on: {
      "click": _vm.goAwardsPage
    }
  }, [_c('div', {
    staticClass: "show-code"
  }, [_vm._v("兑奖码：" + _vm._s(_vm.code))])]), _vm._v(" ")]) : (_vm.awardType === 2) ? _c('div', [_c('div', {
    staticClass: "link"
  }, [_c('a', {
    staticClass: "go-coupon",
    attrs: {
      "href": _vm.couponLink
    }
  }, [_vm._v("查看优惠券")])])]) : (_vm.awardType === 4 && _vm.getCalculusLink) ? _c('div', [_c('div', {
    staticClass: "link calculus-link"
  }, [_c('a', {
    attrs: {
      "href": _vm.getCalculusLink
    }
  }, [_vm._v("中奖啦！立即领取")])])]) : _vm._e(), _vm._v(" "), _vm._v(" ")]), _vm._v(" "), _c('i', {
    staticClass: "cancel",
    on: {
      "click": _vm.cancel
    }
  })])]) : _vm._e()
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-loader/lib/template-compiler.js?id=data-v-7b21ed10!../~/vue-loader/lib/selector.js?type=template&index=0!./components/vue/getaward.vue
 ** module id = 140
 ** module chunks = 1
 **/